module.exports = __webpack_public_path__ + "static/media/saveData.dd39a717.svg";